import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Circular avatar for chat (messages, header, sidebar). Shows image when URL is set; otherwise initials.
 */
const ChatCircleAvatar = ({
    imageUrl,
    initials = '?',
    size = 40,
    avatarBg,
    avatarColor,
    fontSize,
    style,
    className,
}) => {
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        setImageError(false);
    }, [imageUrl]);

    const showImage = imageUrl && !imageError;
    const fs = fontSize ?? (size <= 30 ? 12 : size <= 34 ? 13 : 14);

    return (
        <div
            className={className}
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                background: showImage ? 'transparent' : avatarBg,
                color: avatarColor || '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: fs,
                flexShrink: 0,
                overflow: 'hidden',
                cursor: 'default',
                ...style,
            }}
        >
            {showImage ? (
                <img
                    src={imageUrl}
                    alt=""
                    onError={() => setImageError(true)}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
            ) : (
                initials
            )}
        </div>
    );
};

ChatCircleAvatar.propTypes = {
    imageUrl: PropTypes.string,
    initials: PropTypes.node,
    size: PropTypes.number,
    avatarBg: PropTypes.string,
    avatarColor: PropTypes.string,
    fontSize: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string,
};

export default ChatCircleAvatar;
